import React, { useEffect, useRef, useState } from "react";
import { TypeAnimation } from "react-type-animation";

import { motion, AnimatePresence } from "motion/react";
import { ActionButton } from "../component/buttons";

export const StatsMostPlayedArtist = ({ url }) => {
  return (
    <img
      referrerPolicy="no-referrer"
      className="artist-capsule"
      style={{
        width: 180,
        height: 280,
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.20)",
      }}
      src={url}
    />
  );
};

export const StatsMostPlayedAlbum = ({ url }) => {
  return (
    <img
      referrerPolicy="no-referrer"
      className="Image"
      style={{
        width: 280,
        height: 280,
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.20)",
      }}
      src={url}
    />
  );
};

export const StatsMostPlayedSingle = ({ type, data, next }) => {
  const [hide, setHide] = useState(false);
  const [showResult, setShowResult] = useState(false);

  var title = "";
  var subtitle = "";
  var artwork = "";
  var listenCount = "";

  if (type == "artist" && data.top_artists && data.top_artists.length > 0) {
    title = data.top_artists[0].artist_id.name;
    subtitle = "";
    artwork = data.top_artists[0].artist_id.artwork;
    listenCount = data.top_artists[0].play_count;
  } else if (type == "album" && data.top_albums && data.top_albums.length > 0) {
    title = data.top_albums[0].album_id.name;
    subtitle = data.top_albums[0].album_id.artistName;
    artwork = data.top_albums[0].album_id.artwork;
    listenCount = data.top_albums[0].play_count;
  } else if (type == "song" && data.top_songs && data.top_songs.length > 0) {
    title = data.top_songs[0].song_id.name;
    subtitle = data.top_songs[0].song_id.artistName;
    artwork = data.top_songs[0].song_id.artwork;
    listenCount = data.top_songs[0].play_count;
  }

  return (
    <motion.div className="app-stats-intro-content" key="step-0">
      <div
        className="center-container single-most-played-container"
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: "0%" }}
        exit={{ opacity: 0, y: "-400%" }}
        transition={{
          duration: 1.0,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <TypeAnimation
          className="stats-typer light-headline header-single"
          sequence={[
            "",
            1000,
            "most played ",
            500,
            "most played " + type,
            500,
            () => {
              setShowResult(true);
            },
          ]}
          typeSpeed={420}
        />

        {type == "artist" && (
          <motion.img
            className="artist-shape-badge-background artist-shape-badge-4"
            style={{
              left: "21%",
              top: "25%",
              position: "absolute",
              width: "60%",
            }}
            src={require("../assets/img/artistSingle.svg")}
            initial={{ opacity: 0, y: "100%", scale: 0.0 }}
            animate={{
              opacity: showResult ? 1 : 0,
              y: showResult ? "0%" : "100%",
              scale: showResult ? 1.0 : 0.0,
            }}
            exit={{ opacity: 0, y: "-400%" }}
            transition={{
              duration: 1.0,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          />
        )}

        {type != "artist" && (
          <motion.img
            className="artist-shape-badge-background artist-shape-badge-4"
            style={{
              left: "0px",
              top: "18%",
              position: "absolute",
              width: "50%",
            }}
            src={require("../assets/img/singleBackgroundShape.svg")}
            initial={{ opacity: 0, y: "100%", scale: 0.0 }}
            animate={{
              opacity: showResult ? 1 : 0,
              y: showResult ? "0%" : "100%",
              scale: showResult ? 1.0 : 0.0,
            }}
            exit={{ opacity: 0, y: "-400%" }}
            transition={{
              duration: 1.0,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          />
        )}

        {type != "artist" && (
          <motion.img
            className="artist-shape-badge-background artist-shape-badge-3"
            style={{
              position: "absolute",
              right: "-6px",
              bottom: "46%",
              width: "40%",
            }}
            src={require("../assets/img/singleBackgroundShape2.svg")}
            initial={{ opacity: 0, y: "100%", scale: 0.0 }}
            animate={{
              opacity: showResult ? 1 : 0,
              y: showResult ? "0%" : "100%",
              scale: showResult ? 1.0 : 0.0,
            }}
            exit={{ opacity: 0, y: "-400%" }}
            transition={{
              duration: 1.0,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          />
        )}

        <motion.div
          className="column-layout single-most-played "
          initial={{ opacity: 0, y: "100%" }}
          animate={{
            opacity: showResult ? 1 : 0,
            y: showResult ? "0%" : "100%",
          }}
          exit={{ opacity: 0, y: "-400%" }}
          transition={{
            duration: 1.0,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          {type != "artist" && <StatsMostPlayedAlbum url={artwork} />}
          {type == "artist" && <StatsMostPlayedArtist url={artwork} />}

          <div className="column-layout single-most-played-metadata">
            <h1 className="headline">{title}</h1>
            {type != "artist" && <h3 className="light-headline">{subtitle}</h3>}
          </div>
          <div className="column-layout single-most-played-listen">
            <h2>{listenCount}</h2>
            <p className="light-headline">listens</p>
          </div>
        </motion.div>

        <button onClick={() => next()}>
          <ActionButton title="next" />
        </button>
      </div>
    </motion.div>
  );
};
